import { render, staticRenderFns } from "./LoginComponent.vue?vue&type=template&id=31b53b41&scoped=true&"
import script from "./LoginComponent.vue?vue&type=script&lang=js&"
export * from "./LoginComponent.vue?vue&type=script&lang=js&"
import style0 from "./LoginComponent.vue?vue&type=style&index=0&id=31b53b41&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b53b41",
  null
  
)

export default component.exports